import { BaseProxy } from "@/proxies/BaseProxy";

export class AuthProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `login`,
      parameters,
    });
  }
}
